import { render, staticRenderFns } from "./TipsWords.vue?vue&type=template&id=6c0cfa46&scoped=true"
import script from "./TipsWords.vue?vue&type=script&lang=js"
export * from "./TipsWords.vue?vue&type=script&lang=js"
import style0 from "./TipsWords.vue?vue&type=style&index=0&id=6c0cfa46&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0cfa46",
  null
  
)

export default component.exports